// iOS Safari (and other iOS WebKit browsers) natively scrolls a focused
// element into view, which compounds with react-select's own
// menuShouldScrollIntoView doing the same for its menu, overshooting and
// scrolling the page past the field until a later section (with its own
// background) is what's left in view. Desktop/Android don't exhibit this, so
// callers use this to disable react-select's own scroll-into-view only on
// iOS, leaving every other platform unchanged.
export const isIOSDevice =
  typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent);
